import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LeadFormStepper } from './LeadFormStepper';
export function FinalCtaForm() {
  const [showForm, setShowForm] = useState(false);
  return <section id="lead-form" className="w-full scroll-mt-6 bg-blue-50/60" data-id="element-27">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-6 lg:py-20" data-id="element-28">
        <div className="text-center" data-id="element-29">
          <h2 className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl lg:text-3xl" data-id="element-30">
            Запишитесь на консультацию перед операцией
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-slate-600" data-id="element-31">
            Ответьте на несколько коротких вопросов, чтобы мы могли
            подготовиться к вашей консультации. Павел Петрович лично изучит ваш
            случай и расскажет о следующих шагах.
          </p>
        </div>

        <div className="mt-10" data-id="element-32">
          <AnimatePresence mode="wait" data-id="element-33">
            {!showForm ? <motion.div key="cta" initial={{
            opacity: 1
          }} exit={{
            opacity: 0,
            y: -12
          }} transition={{
            duration: 0.25
          }} className="text-center" data-id="element-34">
                <button type="button" onClick={() => setShowForm(true)} className="w-full rounded-2xl bg-blue-600 px-7 py-4 text-lg font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 sm:w-auto" data-id="element-35">
                  Записаться на консультацию
                </button>
                <p className="mt-4 text-base text-slate-500" data-id="element-36">
                  Мы не навязываем операцию — если она вам не нужна, скажем
                  честно.
                </p>
              </motion.div> : <motion.div key="form" initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: [0.16, 1, 0.3, 1]
          }} data-id="element-37">
                <LeadFormStepper data-id="element-38" />
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}